import React, { useState, useEffect } from "react";
import useSWR from "swr";
import "./dashboard.css";
import DashboardControl, {
  DataSourceWizard,
} from "devexpress-dashboard-react/dashboard-control";
import SelectBox from "devextreme-react/select-box";
import { Button } from "devextreme-react/button";
import { checkRoles } from "../../Utils/helper";
import { apiBaseURL } from "../../Utils/ProjectConstants";

function switchMode(props) {
  return props === "Viewer" ? "Designer" : "Viewer";
}

export default function Dashboard() {
  const [workingModeVar, setWorkingMode] = useState("Viewer"),
    [dashboardId, setDashboardId] = useState("[1] Operations User Hours"), //HARDCODED!
    [store, setStore] = useState([]),
    { data, error } = useSWR(
      `${apiBaseURL}/api/dashboard/dashboards?_=1685484142171`,
      { refreshInterval: 600000 },
    );

  useEffect(() => {
    if (data) {
      setStore({ store: data.map((x) => x.id) });
    }
  }, [data]);

  const onDashboardInitialized = (e) => {
    setDashboardId(e.dashboardId);
  };

  return (
    <div className="content">
      <div className="page-content contentBox">
        <Button
          text={`Switch to ${switchMode(workingModeVar)}`}
          type="normal"
          stylingMode="contained"
          onClick={() => {
            setWorkingMode(switchMode(workingModeVar));
          }}
          style={{ margin: "10px" }}
          visible={checkRoles(6) ? true : false}
        />
        <SelectBox
          dataSource={store}
          width="350px"
          value={dashboardId}
          className="select"
          onValueChanged={(e) => setDashboardId(e.value)}
        ></SelectBox>
        <DashboardControl
          style={{ height: "100vh" }}
          endpoint={`${apiBaseURL}/api/dashboard`}
          defaultWorkingMode="Viewer"
          workingMode={workingModeVar}
          dashboardId={dashboardId}
          onDashboardInitialized={onDashboardInitialized}
          extensions={{ "data-source-wizard": { enableCustomSql: true } }}
        ></DashboardControl>
      </div>
    </div>
  );
}

//https://atlasweb-dev.hq.wsuniar.org:8080
//http://freeman:5055/api/dashboard
